module.exports = __webpack_public_path__ + "static/2-education-a23c2c1e3acaad410735e5417c19e2d2.jpg";